__turbopack_context__.v({
  "agentBubble": "SupportChatWidget-module__udXGqW__agentBubble",
  "approvalActions": "SupportChatWidget-module__udXGqW__approvalActions",
  "approvalCard": "SupportChatWidget-module__udXGqW__approvalCard",
  "approvalChanges": "SupportChatWidget-module__udXGqW__approvalChanges",
  "approvalHeader": "SupportChatWidget-module__udXGqW__approvalHeader",
  "approvalHint": "SupportChatWidget-module__udXGqW__approvalHint",
  "approvalStatus": "SupportChatWidget-module__udXGqW__approvalStatus",
  "approvals": "SupportChatWidget-module__udXGqW__approvals",
  "avatar": "SupportChatWidget-module__udXGqW__avatar",
  "bubble": "SupportChatWidget-module__udXGqW__bubble",
  "capabilityMenu": "SupportChatWidget-module__udXGqW__capabilityMenu",
  "composer": "SupportChatWidget-module__udXGqW__composer",
  "composerActions": "SupportChatWidget-module__udXGqW__composerActions",
  "customerBubble": "SupportChatWidget-module__udXGqW__customerBubble",
  "emptyIcon": "SupportChatWidget-module__udXGqW__emptyIcon",
  "emptyState": "SupportChatWidget-module__udXGqW__emptyState",
  "error": "SupportChatWidget-module__udXGqW__error",
  "handoffBanner": "SupportChatWidget-module__udXGqW__handoffBanner",
  "header": "SupportChatWidget-module__udXGqW__header",
  "headerActions": "SupportChatWidget-module__udXGqW__headerActions",
  "iconBadge": "SupportChatWidget-module__udXGqW__iconBadge",
  "inlineActions": "SupportChatWidget-module__udXGqW__inlineActions",
  "launcher": "SupportChatWidget-module__udXGqW__launcher",
  "launcherCollapseButton": "SupportChatWidget-module__udXGqW__launcherCollapseButton",
  "launcherCollapsed": "SupportChatWidget-module__udXGqW__launcherCollapsed",
  "launcherText": "SupportChatWidget-module__udXGqW__launcherText",
  "launcherWrap": "SupportChatWidget-module__udXGqW__launcherWrap",
  "launcherWrapCollapsed": "SupportChatWidget-module__udXGqW__launcherWrapCollapsed",
  "messageBody": "SupportChatWidget-module__udXGqW__messageBody",
  "messageMeta": "SupportChatWidget-module__udXGqW__messageMeta",
  "messageRow": "SupportChatWidget-module__udXGqW__messageRow",
  "messageRowAgent": "SupportChatWidget-module__udXGqW__messageRowAgent",
  "messageRowCustomer": "SupportChatWidget-module__udXGqW__messageRowCustomer",
  "messages": "SupportChatWidget-module__udXGqW__messages",
  "panel": "SupportChatWidget-module__udXGqW__panel",
  "panelNavigating": "SupportChatWidget-module__udXGqW__panelNavigating",
  "root": "SupportChatWidget-module__udXGqW__root",
  "starterPrompt": "SupportChatWidget-module__udXGqW__starterPrompt",
  "starterPrompts": "SupportChatWidget-module__udXGqW__starterPrompts",
  "status": "SupportChatWidget-module__udXGqW__status",
  "subtitle": "SupportChatWidget-module__udXGqW__subtitle",
  "textarea": "SupportChatWidget-module__udXGqW__textarea",
  "title": "SupportChatWidget-module__udXGqW__title",
  "titleGroup": "SupportChatWidget-module__udXGqW__titleGroup",
  "typingDots": "SupportChatWidget-module__udXGqW__typingDots",
  "typingPulse": "SupportChatWidget-module__udXGqW__typingPulse",
  "unreadDot": "SupportChatWidget-module__udXGqW__unreadDot",
  "workingBubble": "SupportChatWidget-module__udXGqW__workingBubble",
  "workingLine": "SupportChatWidget-module__udXGqW__workingLine",
});
